var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-error"},[_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.realCode))]),_c('div',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(_vm.realMessage)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }